import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useSelector } from 'react-redux';
import styles from './EventDetailPage.module.scss';

import EventCard from '../EventCard';
import {
  isLoadingPagesSeector,
  isLoadingMenueSeector,
  getPageList,
} from '../../redux/selectors/common-selectors';
import ContentNotFound from '../content-not-found/ContentNotFound';
import MapContainer from '../MapContainer/MapContainer';
import BackButtonHeader from '../back-button-header/BackButtonHeader';

const EventDetailPage = ({ location, location: { event = null } }) => {
  const isLoadingPages = useSelector(isLoadingPagesSeector);
  const isLoadingMenu = useSelector(isLoadingMenueSeector);
  const pagesList = useSelector(getPageList);

  const [eventToShow, setEventToShow] = useState(event);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (event) {
      setEventToShow(event);
      setIsLoading(false);
    }
  }, [event]);

  useEffect(() => {
    if (!isLoadingMenu && !isLoadingPages) {
      const menuSlug = location.pathname.split('/')[1];
      const pageSlug = location.pathname.split('/')[2];

      const pageData = pagesList.find(({ slug }) => slug === pageSlug);
      if (pageData?.menu.slug === menuSlug) {
        setEventToShow(pageData);
        setIsLoading(false);
      } else {
        setTimeout(() => setIsLoading(false), 1000);
      }
    }
  }, [isLoadingMenu, isLoadingPages, pagesList, location]);

  const renderMap =
    !!eventToShow?.lat &&
    !!eventToShow?.lng &&
    eventToShow?.lat !== '0' &&
    eventToShow?.lng !== '0';

  if (isLoading || isLoadingMenu || isLoadingPages)
    return <div className={styles.loadingContainer}>Loading</div>;
  if (!isLoading && !eventToShow) return <ContentNotFound />;

  return (
    <div className={styles.container}>
      <BackButtonHeader title="BACK TO LIST" />
      <div className={styles.contentWrapper}>
        {/* TODO: modify map data to not pass the whole events */}
        <div className={styles.mapWrapper}>
          {renderMap && <MapContainer selectedEvent={eventToShow} />}
        </div>
        <div
          className={classnames(
            styles.eventCardWrapper,
            // styles.downPosiiton
            renderMap ? styles.downPosiiton : styles.upPosition
          )}
        >
          <EventCard
            event={eventToShow}
            containerStyle={styles.eventCardContainer}
            linkButtonStyle={styles.link}
            descriptionStyle={styles.eventCardDescriptionStyle}
            isLink={false}
          />
        </div>
      </div>
    </div>
  );
};

EventDetailPage.propTypes = {
  event: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
};

EventDetailPage.defaultProps = {
  event: {},
  location: null,
};

export default EventDetailPage;
